import { FormControlLabel, Switch } from "@mui/material";
import React from "react";

type CustomSwitchType = {
    label: string,
    isChecked: boolean,
    onChange: Function
}

const CustomSwitch = (props: CustomSwitchType) => {
    return (
        <FormControlLabel control={<Switch checked={props.isChecked} onChange={() => props.onChange()} />} label={props.label} />
    )
}

export default CustomSwitch;